import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import IntersectionObserver from 'react-intersection-observer';
import {User} from 'interfaces';
import {Section} from 'components/UIKit';
import {ListingShop, ContactTrackingData} from '../../types';
import {ContactForm} from './ContactForm';
import * as locales from './locales';

export interface ContactMobileProps {
  id: string;
  user?: User;
  shop: ListingShop;
  isOwnStore: boolean;
  authenticityToken: string;
  contactTracking: ContactTrackingData;
  onVisibilityChange?: (inView: boolean) => any;
}

function ContactMobileComponent({
  id,
  user,
  shop,
  isOwnStore,
  contactTracking,
  authenticityToken,
  onVisibilityChange,
  i18n,
}: ContactMobileProps & WithI18nProps) {
  const formProps = {
    show: true,
    shop,
    user,
    isOwnStore,
    contactTracking,
    authenticityToken,
  };

  return (
    <IntersectionObserver threshold={0.1} onChange={onVisibilityChange}>
      <Section
        id={id}
        heading={i18n.translate('contactSeller')}
        headingProps={{type: 'h5', component: 'h2'}}
        spacing="small"
        fullWidth
      >
        <ContactForm showCancel={false} {...formProps} />
      </Section>
    </IntersectionObserver>
  );
}

export const ContactMobile = withI18n({
  id: 'ContactMobile',
  fallback: locales.en,
})(ContactMobileComponent);
